import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { playerDashboardApi } from '../../services/api';
import { useAuth } from '../../context/AuthContext';

const ID_TYPE_LABELS = {
  bai_id:         'BAI ID',
  affiliation_id: 'Affiliation ID',
  national_id:    'National ID',
};

const MyPlayerProfile = () => {
  const { user } = useAuth();
  const [profile, setProfile] = useState(null);
  const [identifiers, setIdentifiers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    playerDashboardApi.getMyProfile()
      .then(res => {
        setProfile(res.data.profile || null);
        setIdentifiers(res.data.identifiers || []);
      })
      .catch(err => console.error('MyPlayerProfile load error:', err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <div style={{ display: 'flex', justifyContent: 'center', padding: '4rem' }}><div className="spinner" /></div>;
  }

  return (
    <div style={{ maxWidth: 600, margin: '0 auto', padding: '2rem 1rem' }}>
      <h1 style={{ fontSize: '1.4rem', fontWeight: 700, color: '#111827', marginBottom: '1.5rem' }}>My Player Profile</h1>

      {/* Account info */}
      <div style={{ background: 'white', border: '1px solid #e5e7eb', borderRadius: 12, padding: '1.5rem', marginBottom: '1rem' }}>
        <div style={{ fontSize: '0.72rem', fontWeight: 600, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '1rem' }}>
          Account
        </div>
        <Row label="Name" value={user?.name} />
        <Row label="Email" value={user?.email} />
      </div>

      {/* Player profile */}
      {profile ? (
        <div style={{ background: 'white', border: '1px solid #e5e7eb', borderRadius: 12, padding: '1.5rem', marginBottom: '1rem' }}>
          <div style={{ fontSize: '0.72rem', fontWeight: 600, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '1rem' }}>
            Player Identity
          </div>
          <Row label="Display Name" value={profile.display_name} />
          {profile.sport && <Row label="Sport" value={profile.sport.replace('_', ' ')} capitalize />}

          {identifiers.length > 0 && (
            <>
              <div style={{ height: 1, background: '#f3f4f6', margin: '1rem 0' }} />
              <div style={{ fontSize: '0.72rem', fontWeight: 600, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.75rem' }}>
                IDs & Registrations
              </div>
              {identifiers.map((id, i) => (
                <Row
                  key={i}
                  label={ID_TYPE_LABELS[id.id_type] || id.id_type}
                  value={id.id_value}
                />
              ))}
            </>
          )}

          <div style={{ marginTop: '1rem', paddingTop: '1rem', borderTop: '1px solid #f3f4f6' }}>
            <Link
              to={`/profiles/${profile.id}`}
              style={{ fontSize: '0.85rem', color: '#0D9488', fontWeight: 500, textDecoration: 'none' }}
            >
              View public profile →
            </Link>
          </div>
        </div>
      ) : (
        <div style={{ background: '#fefce8', border: '1px solid #fde68a', borderRadius: 12, padding: '1.25rem 1.5rem' }}>
          <p style={{ color: '#854d0e', fontSize: '0.875rem', margin: 0, fontWeight: 500 }}>
            No player profile is linked to your account yet. Your profile is created when an organizer adds you to a tournament.
          </p>
        </div>
      )}

      {/* Account settings link */}
      <div style={{ marginTop: '0.75rem', textAlign: 'right' }}>
        <Link to="/profile" style={{ fontSize: '0.8rem', color: '#6b7280', textDecoration: 'none' }}>
          Account settings →
        </Link>
      </div>
    </div>
  );
};

function Row({ label, value, capitalize }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '6px 0', gap: '1rem' }}>
      <span style={{ fontSize: '0.85rem', color: '#6b7280', fontWeight: 500, flexShrink: 0 }}>{label}</span>
      <span style={{ fontSize: '0.85rem', color: '#111827', fontWeight: 500, textAlign: 'right', textTransform: capitalize ? 'capitalize' : 'none' }}>
        {value || <span style={{ color: '#d1d5db' }}>—</span>}
      </span>
    </div>
  );
}

export default MyPlayerProfile;
